import React, { useState } from 'react';
import axios from 'axios';
import logo from '../assets/studium-logo.webp';
import Sidebar from './Sidebar';
import MyResults from './MyResults';
import HomePanel from './panels/HomePanel';
import AboutUcatPanel from './panels/AboutUcatPanel';
import ExcellenceWeekPanel from './panels/ExcellenceWeekPanel';
import SelfGuidedPanel from './panels/SelfGuidedPanel';
import ExamListPanel from './panels/ExamListPanel';
import QuestionBankPanel from './panels/QuestionBankPanel';
import HelpPanel from './panels/HelpPanel';
import UserManagementPanel from './panels/UserManagementPanel';
import './ExamPicker.css';
import './Shell.css';

const ROLE_LABELS = { admin: 'Administrator', tutor: 'Tutor', student: 'Student' };

function Shell({ user, onSignOut, onStartPractice, onStartMiniMock, onStartFullMock, apiUrl, nav, setNav }) {
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [ownPasswordForm, setOwnPasswordForm] = useState({ current_password: '', new_password: '' });
  const [ownPasswordMessage, setOwnPasswordMessage] = useState('');

  const handleChangeOwnPassword = async (e) => {
    e.preventDefault();
    setOwnPasswordMessage('');
    try {
      await axios.patch(`${apiUrl}/auth/change-password`, ownPasswordForm);
      setOwnPasswordMessage('Password changed successfully.');
      setOwnPasswordForm({ current_password: '', new_password: '' });
      setTimeout(() => setShowChangePassword(false), 1500);
    } catch (err) {
      setOwnPasswordMessage(err.response?.data?.error || 'Failed to change password');
    }
  };

  const renderPanel = () => {
    switch (nav.section) {
      case 'home':
        return <HomePanel user={user} apiUrl={apiUrl} />;
      case 'about-ucat':
        return <AboutUcatPanel user={user} apiUrl={apiUrl} />;
      case 'excellence':
        return nav.sub ? (
          <ExcellenceWeekPanel week={nav.sub} user={user} apiUrl={apiUrl} onStartPractice={onStartPractice} />
        ) : (
          <div className="panel-placeholder">Select a week from the sidebar.</div>
        );
      case 'self-guided':
        return nav.sub ? (
          <SelfGuidedPanel topic={nav.sub} user={user} apiUrl={apiUrl} onStartPractice={onStartPractice} />
        ) : (
          <div className="panel-placeholder">Select a module from the sidebar.</div>
        );
      case 'question-bank':
        return <QuestionBankPanel onSelect={onStartPractice} />;
      case 'practice-exams':
        return (
          <ExamListPanel
            type={nav.sub === 'full' ? 'full' : 'mini'}
            apiUrl={apiUrl}
            onSelect={(id) => (nav.sub === 'full' ? onStartFullMock(id) : onStartMiniMock(id))}
          />
        );
      case 'my-results':
        return (
          <MyResults
            user={user}
            embedded
            apiUrl={apiUrl}
            onRetakePractice={onStartPractice}
            onRetakeMiniMock={onStartMiniMock}
            onRetakeFullMock={onStartFullMock}
          />
        );
      case 'help':
        return <HelpPanel />;
      case 'user-management':
        return user.role === 'admin' ? (
          <UserManagementPanel user={user} apiUrl={apiUrl} />
        ) : (
          <div className="panel-placeholder">Not available.</div>
        );
      default:
        return <HomePanel user={user} apiUrl={apiUrl} />;
    }
  };

  return (
    <div className="container shell-container">
      <div className="header">
        <div className="header-brand">
          <img src={logo} alt="The Studium Education" className="header-logo" />
          <h1>UCAT Practice Platform</h1>
        </div>
        <div className="header-actions">
          <div className="user-info">
            <div className="user-email">{user.email}</div>
            <div className="user-role">{ROLE_LABELS[user.role] || 'Student'}</div>
          </div>
          {user.role === 'admin' && (
            <button className="btn btn-secondary" onClick={() => setShowChangePassword(true)}>
              Change My Password
            </button>
          )}
          <button className="btn btn-danger" onClick={onSignOut}>
            Sign Out
          </button>
        </div>
      </div>

      <div className="shell-body">
        <Sidebar user={user} nav={nav} setNav={setNav} onStartPractice={onStartPractice} />
        <div className="shell-content">{renderPanel()}</div>
      </div>

      {showChangePassword && (
        <div className="picker-overlay" onClick={() => setShowChangePassword(false)}>
          <div className="picker" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 420 }}>
            <div className="picker-header">
              <span>Change My Password</span>
              <button className="picker-close" onClick={() => setShowChangePassword(false)}>×</button>
            </div>
            <div className="picker-content">
              <form onSubmit={handleChangeOwnPassword}>
                {ownPasswordMessage && (
                  <div className={ownPasswordMessage.includes('success') ? 'success' : 'error'}>{ownPasswordMessage}</div>
                )}
                <div className="form-group">
                  <label>Current Password</label>
                  <input
                    type="password"
                    value={ownPasswordForm.current_password}
                    onChange={(e) => setOwnPasswordForm((p) => ({ ...p, current_password: e.target.value }))}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>New Password</label>
                  <input
                    type="password"
                    value={ownPasswordForm.new_password}
                    onChange={(e) => setOwnPasswordForm((p) => ({ ...p, new_password: e.target.value }))}
                    required
                    minLength={6}
                  />
                </div>
                <button type="submit" className="btn btn-primary">Change Password</button>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Shell;
